import React from "react";
import Modal from "react-modal";
import styled from "styled-components";

import OutfitModalMenu from "./OutfitModalMenu";
import ViewButton from "./ViewButton";

const customStyles = {
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.33)",
  },
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    borderRadius: "2rem",
    width: "60vw",
    height: "680px",
    padding: 0,
    backgroundColor: "#FFFCFC",
  },
};

const OutfitModal = (props: any) => {
  const { className, recommendation, children } = props;
  const [isOpen, setIsOpen] = React.useState(false);

  const modalCanvasRef = React.useRef<HTMLCanvasElement | null>(null);

  function openModal() {
    setIsOpen(!isOpen);
  }

  function closeModal() {
    setIsOpen(!isOpen);
  }

  function createOutfitCanvas() {
    // Create canvas and append to modal content
    const modalRoot = document.getElementsByClassName("ReactModal__Content")[0];
    if (!modalCanvasRef.current) {
      modalCanvasRef.current = document.createElement("canvas");
    }
    modalCanvasRef.current.width = 600;
    modalCanvasRef.current.height = 680;
    modalRoot?.appendChild(modalCanvasRef.current!);
    const renderContext = modalCanvasRef.current?.getContext("2d");

    // Fill in canvas background and draw outfit image
    if (renderContext) {
      renderContext.fillStyle = "#F5F5F5";
      renderContext.fillRect(0, 0, 600, 680);
      const topImage = new Image();
      const bottomImage = new Image();
      const shoeImage = new Image();

      bottomImage.onload = () => {
        const ratio = bottomImage.width / bottomImage.height;
        let width = 160;
        let height = width / ratio;
        if (height > 320) {
          height = 320;
          width = 320 * ratio;
        }
        renderContext.imageSmoothingQuality = "high";
        renderContext.drawImage(bottomImage, 190, 280, width, height);
      };
      bottomImage.src = recommendation[1].image_url;

      topImage.onload = () => {
        const ratio = topImage.width / topImage.height;
        const height = 220;
        const width = height * ratio;
        renderContext.imageSmoothingQuality = "high";
        renderContext.drawImage(topImage, 80, 50, width, height);
      };
      topImage.src = recommendation[0].image_url;

      shoeImage.onload = () => {
        const ratio = shoeImage.width / shoeImage.height;
        const width = 160;
        const height = width / ratio;
        renderContext.imageSmoothingQuality = "high";
        renderContext.drawImage(shoeImage, 380, 420, width, height);
      };
      shoeImage.src = recommendation[2].image_url;
    }
  }

  return (
    <ViewButton
      width={110}
      height={44}
      color={"#5B5B5B"}
      label="View look"
      className={"viewButton"}
      onClick={openModal}
    >
      <Modal
        isOpen={isOpen}
        className={className}
        onRequestClose={closeModal}
        shouldCloseOnOverlayClick
        onAfterOpen={createOutfitCanvas}
        style={customStyles}
        appElement={document.getElementById("app") || undefined}
      >
        <Wrapper>
          <OutfitModalMenu recommendation={recommendation}></OutfitModalMenu>
          {children}
        </Wrapper>
      </Modal>
    </ViewButton>
  );
};

const Wrapper = styled.div`
  display: flex;
  padding: 5rem 3rem;
  width: calc(60vw - 600px);
  overflow-y: scroll;
`;

export default OutfitModal;
